import React from 'react';
import SettingsTemplates from './SettingsTemplates';

function TemplateLibraryPage() {
  // SettingsTemplates has its own header, so we don't add another
  return <SettingsTemplates />;
}

export default TemplateLibraryPage;
